module.exports = __webpack_public_path__ + "static/media/home_03_10.0ac6f0f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/home_03_10.mp4
// module id = I1Rv
// module chunks = 1